export default {"src":"/_next/static/media/room-category-lagoon.d6582ede.svg","height":48,"width":48};